import "./chargeonAtDreamforce.scss";
import "../../src-utilities/header";
import "../../src-utilities/footer";
import Swiper from "./../../../node_modules/swiper";
import { Navigation, Autoplay, Keyboard, Pagination } from "swiper/modules";
import JustValidate from "just-validate";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

let swiperOptions = {
  modules: [Autoplay],
  slidesPerView: "auto",
  spaceBetween: 50,
  speed: 5000,
  freeMode: true,
  freeModeMomentum: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  loop: true,
  breakpoints: {
    0: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    600: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 50,
    },
  },
};

if (window.innerWidth < 900) {
  new Swiper(".customers-logo", swiperOptions);
}

// iframe tumbnail
let iframeSection = document.querySelector(".iframe");
let ytFalse = document.querySelector(".yt-false");
let ytImg = document.querySelector(".yt-img");
let ytLink =
  "https://www.youtube.com/embed/eGT8_QfW8UE?si=SIt93Rugj6KHx2K-?autoplay=1&modestbranding=1&rel=0&showinfo=0";
let youtube_video_id = ytLink
  .match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)
  .pop();

if (youtube_video_id.length === 11) {
  let video_thumbnail =
    "//img.youtube.com/vi/" + youtube_video_id + "/maxresdefault.jpg";
  ytImg.src = video_thumbnail;
}

ytFalse.addEventListener("click", function () {
  iframeSection.innerHTML =
    `<iframe loading="lazy" class="yt-autoplay" src="` +
    ytLink +
    `" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
  let ytVideo = document.querySelector(".yt-autoplay");
  if (ytVideo) {
    if (ytLink.indexOf("?") != -1) {
      ytVideo.src = ytLink + "&autoplay=1";
    } else {
      ytVideo.src = ytLink + "?autoplay=1";
    }
    console.log("true");
  } else {
    console.error("iframe not found .");
  }
});

const swiper = new Swiper(".testimonialSwiper", {
  modules: [Navigation, Autoplay, Keyboard, Pagination],
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  speed: 600,
  effect: "slide",
});

const dreamforceBoothForm = document.getElementById(
  "dreamforce-booth-contact-us-form",
);
const dreamforceBoothFormData = new JustValidate(dreamforceBoothForm);

dreamforceBoothFormData
  .addField("#booth-form-firstname", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
    {
      rule: "customRegexp",
      value: /^(?=\S)([A-Za-z.]+(?:\s+[.A-Za-z]+){1,})$/,
      errorMessage: "Enter Valid Full Name",
    },
  ])
  .addField("#booth-form-company", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
  ])
  .addField("#booth-form-email", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ])
  .addField("#booth-form-meeting-agenda", [
    {
      rule: "required",
    },
  ]);

let GoogleSendURL =
  "https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec";

let loader = document.querySelector(".loader");

dreamforceBoothForm.addEventListener("submit", async (event) => {
  event.preventDefault();
  if (dreamforceBoothFormData.isValid == false) {
    return false;
  }
  loader.classList.add("active");

  let formData = new FormData(event.target);
  let fullName = formData.get("lfirstname").split(" ");
  let firstName, lastName;
  [firstName, ...lastName] = fullName;
  lastName = lastName.join(" ");
  formData.set("lfirstname", firstName);
  formData.set("llastname", lastName);
  formData.append("sendurlvalue", window.location.href);
  formData.append("lsource", "MEC-ChargeOnBooth2026");

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  // Initiate the Sales IQ visitor data
  if (window.$zoho && window.$zoho.salesiq) {
    try {
      $zoho.salesiq.visitor.uniqueid();
      $zoho.salesiq.visitor.name(firstName + " " + lastName);
      $zoho.salesiq.visitor.email(formData.get("lemail"));
      console.log("SalesIQ Name/Email set");
    } catch (error) {
      console.warn("SalesIQ Error:", error);
    }
  }

  const raw = JSON.stringify({
    firstName: formData.get("lfirstname"),
    lastName: formData.get("llastname"),
    email: formData.get("lemail"),
    company: formData.get("lcompany"),
    Meeting_Preference: formData.get("meetingAgenda"),
    leadSource: formData.get("lsource"),
    websiteVisitURL: window.location.href,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const googleRequestOptions = {
    method: "GET",
    redirect: "follow",
  };
  let request = "?";
  [...formData].forEach(([key, value], index) => {
    request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
  });

  // Request 1: Main Backend
  const backendRequest = fetch(
    "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
    requestOptions,
  );

  // Request 2: Update the Google Sheet Data
  const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

  // Waiting until these request get's completed
  try {
    await Promise.allSettled([backendRequest, googleRequest]);
  } catch (e) {
    console.error("API Error", e);
  }

  // Redirect
  window.location.href = "https://products.cyntexa.com/success/";
});

const BindEvent = () => {
  let faq_question = document.getElementsByClassName("faq-question");
  let hiddenFaqs = document.querySelectorAll(".hidden-faq");
  let viewAllFaqBtn = document.querySelector(".faq-view-btn");

  for (let i = 0; i < faq_question.length; i++) {
    const question = faq_question[i];
    question.addEventListener("click", function (e) {
      let all_faq = document.getElementsByClassName("faq");
      let isopen = e.currentTarget.parentNode.classList.contains("active");
      for (let index = 0; index < all_faq.length; index++) {
        all_faq[index].classList.remove("active");
      }
      if (isopen == false) {
        e.currentTarget.parentNode.classList.add("active");
      }
    });
  }

  viewAllFaqBtn.addEventListener("click", () => {
    if (!viewAllFaqBtn.classList.contains("active")) {
      viewAllFaqBtn.textContent = "View Less";
      viewAllFaqBtn.classList.add("active");
      hiddenFaqs.forEach((hiddenFaq) => {
        hiddenFaq.style.display = "flex";
      });
    } else {
      viewAllFaqBtn.textContent = "View All";
      viewAllFaqBtn.classList.remove("active");
      hiddenFaqs.forEach((hiddenFaq) => {
        hiddenFaq.style.display = "none";
      });
    }
  });
};
BindEvent();

const initAccordions = () => {
  const accordionBoxes = document.querySelectorAll(
    ".overview-section .accordion-box",
  );

  accordionBoxes.forEach((box) => {
    if (box.classList.contains("active")) {
      const desc = box.querySelector(".accordion-description");
      if (desc) {
        desc.style.maxHeight = desc.scrollHeight + "px";
      }
    }

    box.addEventListener("click", (e) => {
      if (e.target.closest(".accordion-description")) {
        return;
      }

      const isActive = box.classList.contains("active");

      accordionBoxes.forEach((otherBox) => {
        if (otherBox !== box) {
          otherBox.classList.remove("active");
          const desc = otherBox.querySelector(".accordion-description");
          if (desc) {
            desc.style.maxHeight = null;
          }
        }
      });

      if (isActive) {
        box.classList.remove("active");
        const desc = box.querySelector(".accordion-description");
        if (desc) {
          desc.style.maxHeight = null;
        }
      } else {
        box.classList.add("active");
        const desc = box.querySelector(".accordion-description");
        if (desc) {
          desc.style.maxHeight = desc.scrollHeight + "px";
        }
      }
    });
  });
};
initAccordions();

// Clouds Specialize Section

ScrollTrigger.matchMedia({
  "(min-width: 1001px)": function () {
    gsap.to(".main-box", {
      y: (index) => index * 125,
      duration: 3,
      stagger: 1,
      opacity: 1,
      scrollTrigger: {
        trigger: ".clouds-specialize",
        scroller: "body",
        start: "top 50%",
        end: "bottom 95%",
        scrub: 2,
      },
    });
  },

  "(min-width: 661px) and (max-width: 1000px)": function () {
    gsap.to(".main-box", {
      y: (index) => index * 180,
      opacity: 1,
      stagger: 0.3,
      duration: 1,
      scrollTrigger: {
        trigger: ".clouds-specialize",
        scroller: "body",
        start: "top 80%",
        end: "bottom 95%",
        scrub: 1,
      },
    });
  },

  "(max-width: 660px)": function () {
    gsap.to(".main-box", {
      y: (index) => index * 130,
      opacity: 1,
      stagger: 0.3,
      duration: 1,
      scrollTrigger: {
        trigger: ".clouds-specialize",
        scroller: "body",
        start: "top 80%",
        end: "bottom 95%",
        scrub: 1,
      },
    });
  },
});

// Reserve Popup
let reservePopUp = document.querySelector(".reserve-spot-popup-screen");
let reserveOpen = document.querySelectorAll(".reserve-open");
let reserveClose = document.querySelector(".reserve-close-btn");
const rocketEl = document.querySelector(".popup-form-rocket-element");

reserveOpen.forEach((e) => {
  e.addEventListener("click", () => {
    reservePopUp.classList.add("open");
    if (e.classList.contains("grab-before-dreamforce-start")) {
      if (rocketEl) rocketEl.style.display = "none";
      document.querySelector(".popup-form-rocket-element").style.display =
        "none";
      reservePopUp.querySelector(".popup-heading").innerHTML =
        "Let's Fix It Before Dreamforce Starts";
      reservePopUp.querySelector(".popup-description").innerHTML =
        "Grab 15 minutes with our team and walk in with your payment flow already sorted.";
    } else {
      if (rocketEl) rocketEl.style.display = "block"; // Reset back to visible
      reservePopUp.querySelector(".popup-heading").innerHTML =
        `Let's Connect at <span class="heading-span">Dream<i>f</i>orce <span class="year">2026</span></span>`;
      reservePopUp.querySelector(".popup-description").innerHTML =
        "Planning to stop by? Share your details and we'll see you at the booth.";
    }
  });
});

reserveClose.addEventListener("click", () => {
  reservePopUp.classList.remove("open");
});

window.addEventListener("keyup", (e) => {
  if (e.key === "Escape") reservePopUp.classList.remove("open");
});
// Reserve Popup

// region Form Popup JS Code
const validate_popup = new JustValidate("#chargeon-dreamforce-popup-form");

validate_popup
  .addField("#chargeon-dreamforce-fullname", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
    {
      rule: "customRegexp",
      value: /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/,
      errorMessage: "Enter Valid Full Name",
    },
  ])
  .addField("#chargeon-dreamforce-email", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ])
  .addField("#chargeon-dreamforce-company", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
    {
      rule: "customRegexp",
      value:
        /^(?=.*[a-zA-Z])[a-zA-Z0-9\-_.,;:?!(){}[\]<>@#$%^&*+=|\\\/\s]{1,120}$/,
      errorMessage: "Enter Valid Company Name",
    },
  ])
  .addField("#chargeon-dreamforce-meeting-agenda", [
    {
      rule: "required",
    },
  ]);

document
  .querySelector("#chargeon-dreamforce-popup-form")
  .addEventListener("submit", async (event) => {
    event.preventDefault();
    if (validate_popup.isValid == false) {
      return false;
    }
    loader.classList.add("active");
    const form = document.getElementById("chargeon-dreamforce-popup-form");
    const formData = new FormData(form);
    let fullName = formData.get("lfullname").split(" ");
    let firstName, lastName;
    [firstName, ...lastName] = fullName;
    lastName = lastName.join(" ");
    formData.set("lfirstname", firstName);
    formData.set("llastname", lastName);
    formData.append("sendurlvalue", window.location.href);
    formData.set("lsource", "MEC-ChargeOnBooth2026");

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // Initiate the Sales IQ visitor data
    if (window.$zoho && window.$zoho.salesiq) {
      try {
        $zoho.salesiq.visitor.uniqueid();
        $zoho.salesiq.visitor.name(firstName + " " + lastName);
        $zoho.salesiq.visitor.email(formData.get("lemail"));
        console.log("SalesIQ Name/Email set");
      } catch (error) {
        console.warn("SalesIQ Error:", error);
      }
    }

    let raw = JSON.stringify({
      firstName: formData.get("lfirstname"),
      lastName: formData.get("llastname"),
      email: formData.get("lemail"),
      company: formData.get("lcompany"),
      Meeting_Preference: formData.get("meetingAgenda"),
      leadSource: formData.get("lsource"),
      websiteVisitURL: window.location.href,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const googleRequestOptions = {
      method: "GET",
      redirect: "follow",
    };
    let request = "?";
    [...formData].forEach(([key, value], index) => {
      request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
    });

    // Request 1: Main Backend
    const backendRequest = fetch(
      "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
      requestOptions,
    );

    // Request 2: Update the Google Sheet Data
    const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

    // Waiting until these request get's completed
    try {
      await Promise.allSettled([backendRequest, googleRequest]);
    } catch (e) {
      console.error("API Error", e);
    }

    // Redirect
    window.location.href = "https://products.cyntexa.com/success/";
  });
// endregion  Form Popup JS Code

// region Footer Contact Form
const validate_footer = new JustValidate("#chargeon-booth-footer-form");

validate_footer
  .addField("#chargeon-booth-footer-fullname", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
    {
      rule: "customRegexp",
      value: /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/,
      errorMessage: "Enter Valid Full Name",
    },
  ])
  .addField("#chargeon-booth-footer-Email", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ]);

document
  .querySelector("#chargeon-booth-footer-form")
  .addEventListener("submit", async (event) => {
    event.preventDefault();
    if (validate_footer.isValid == false) {
      return false;
    }

    loader.classList.add("active");
    const form = document.getElementById("chargeon-booth-footer-form");
    const formData = new FormData(form);
    let fullName = formData.get("lfullname").split(" ");
    let firstName, lastName;
    [firstName, ...lastName] = fullName;
    lastName = lastName.join(" ");
    formData.set("lfirstname", firstName);
    formData.set("llastname", lastName);
    formData.append("sendurlvalue", window.location.href);
    formData.set("lsource", "MEC-ChargeOnBooth2026");

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // Initiate the Sales IQ visitor data
    if (window.$zoho && window.$zoho.salesiq) {
      try {
        $zoho.salesiq.visitor.uniqueid();
        $zoho.salesiq.visitor.name(firstName + " " + lastName);
        $zoho.salesiq.visitor.email(formData.get("lemail"));
        console.log("SalesIQ Name/Email set");
      } catch (error) {
        console.warn("SalesIQ Error:", error);
      }
    }

    let raw = JSON.stringify({
      firstName: formData.get("lfirstname"),
      lastName: formData.get("llastname"),
      email: formData.get("lemail"),
      leadSource: formData.get("lsource"),
      websiteVisitURL: window.location.href,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const googleRequestOptions = {
      method: "GET",
      redirect: "follow",
    };
    let request = "?";
    [...formData].forEach(([key, value], index) => {
      request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
    });

    // Request 1: Main Backend
    const backendRequest = fetch(
      "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
      requestOptions,
    );

    // Request 2: Update the Google Sheet Data
    const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

    // Waiting until these request get's completed
    try {
      await Promise.allSettled([backendRequest, googleRequest]);
    } catch (e) {
      console.error("API Error", e);
    }

    // Redirect
    window.location.href = "https://products.cyntexa.com/success/";
  });

// endregion Footer Contact Form

//footer contact form mobile
const validate_footer_mobile = new JustValidate(
  "#chargeon-booth-footer-mobile",
);

validate_footer_mobile
  .addField("#chargeon-booth-footer-fullname-mobile", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
    {
      rule: "customRegexp",
      value: /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/,
      errorMessage: "Enter Valid Full Name",
    },
  ])
  .addField("#chargeon-booth-footer-Email-mobile", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ]);

document
  .querySelector("#chargeon-booth-footer-mobile")
  .addEventListener("submit", async (event) => {
    event.preventDefault();
    if (validate_footer_mobile.isValid == false) {
      return false;
    }

    loader.classList.add("active");
    const form = document.getElementById("chargeon-booth-footer-mobile");
    const formData = new FormData(form);
    let fullName = formData.get("lfullname").split(" ");
    let firstName, lastName;
    [firstName, ...lastName] = fullName;
    lastName = lastName.join(" ");
    formData.set("lfirstname", firstName);
    formData.set("llastname", lastName);
    formData.append("sendurlvalue", window.location.href);
    formData.set("lsource", "MEC-ChargeOnBooth2026");

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // Initiate the Sales IQ visitor data
    if (window.$zoho && window.$zoho.salesiq) {
      try {
        $zoho.salesiq.visitor.uniqueid();
        $zoho.salesiq.visitor.name(firstName + " " + lastName);
        $zoho.salesiq.visitor.email(formData.get("lemail"));
        console.log("SalesIQ Name/Email set");
      } catch (error) {
        console.warn("SalesIQ Error:", error);
      }
    }

    let raw = JSON.stringify({
      firstName: formData.get("lfirstname"),
      lastName: formData.get("llastname"),
      email: formData.get("lemail"),
      leadSource: formData.get("lsource"),
      websiteVisitURL: window.location.href,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const googleRequestOptions = {
      method: "GET",
      redirect: "follow",
    };
    let request = "?";
    [...formData].forEach(([key, value], index) => {
      request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
    });

    // Request 1: Main Backend
    const backendRequest = fetch(
      "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
      requestOptions,
    );

    // Request 2: Update the Google Sheet Data
    const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

    // Waiting until these request get's completed
    try {
      await Promise.allSettled([backendRequest, googleRequest]);
    } catch (e) {
      console.error("API Error", e);
    }

    // Redirect
    window.location.href = "https://products.cyntexa.com/success/";
  });

// CTA - Dowload ChargeOn Capabilities List Form
const downloadChargeonCapabilities = new JustValidate(
  "#download-chargeon-capabilities-list",
);

downloadChargeonCapabilities.addField("#download-chargeon-capabilities-email", [
  {
    rule: "required",
  },
  {
    rule: "email",
  },
  {
    validator: (value) => {
      let emailRegex =
        /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
      return emailRegex.test(value);
    },
    errorMessage: "Please Enter Valid Email Address",
  },
]);

document
  .querySelector("#download-chargeon-capabilities-list")
  .addEventListener("submit", async (event) => {
    event.preventDefault();
    if (downloadChargeonCapabilities.isValid === false) {
      return false;
    }

    loader.classList.add("active");
    const form = document.getElementById("download-chargeon-capabilities-list");
    const formData = new FormData(form);
    formData.append("sendurlvalue", window.location.href);
    formData.set("lsource", "MEC-ChargeOnBooth2026");

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // Initiate the Sales IQ visitor data
    if (window.$zoho && window.$zoho.salesiq) {
      try {
        $zoho.salesiq.visitor.uniqueid();
        // $zoho.salesiq.visitor.name(firstName + " " + lastName);
        $zoho.salesiq.visitor.email(formData.get("lemail"));
        console.log("SalesIQ Name/Email set");
      } catch (error) {
        console.warn("SalesIQ Error:", error);
      }
    }

    let raw = JSON.stringify({
      email: formData.get("lemail"),
      leadSource: formData.get("lsource"),
      websiteVisitURL: window.location.href,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const googleRequestOptions = {
      method: "GET",
      redirect: "follow",
    };
    let request = "?";
    [...formData].forEach(([key, value], index) => {
      request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
    });

    // Request 1: Main Backend
    const backendRequest = fetch(
      "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
      requestOptions,
    );

    // Request 2: Update the Google Sheet Data
    const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

    // Waiting until these request get's completed
    try {
      await Promise.allSettled([backendRequest, googleRequest]);
    } catch (e) {
      console.error("API Error", e);
    }

    loader.classList.remove("active");

    // Trigger PDF download (fetch as blob and save to force direct download)
    try {
      const response = await fetch(
        "https://cyntexa.com/PDF/chargeon-complete-features-capabilities-deck.pdf",
      );
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(
        new Blob([blob], { type: "application/octet-stream" }),
      );
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "chargeon-complete-features-capabilities-deck.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error(
        "Failed to force download, falling back to opening in a new tab:",
        error,
      );
      const link = document.createElement("a");
      link.href =
        "https://cyntexa.com/PDF/chargeon-complete-features-capabilities-deck.pdf";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    // Change button text and style it
    const submitBtn = form.querySelector(".button-box button");
    if (submitBtn) {
      submitBtn.innerHTML = "PDF Downloaded";
      submitBtn.disabled = true;
      submitBtn.style.pointerEvents = "none";
      submitBtn.style.opacity = "0.8";
    }

    form.reset();
  });

// CTA - Dowload ChargeOn Capabilities List Form
